import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Container,
  Form,
  InputGroup,
  Overlay,
  Row,
  Tooltip,
} from "react-bootstrap";

import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import DemoLogo from "../assets/images/quantummain.svg";

import CategoryListTab from "../Modals/CategoryListTab";
import crossarrow from "../assets/images/crossarrow.svg";
import toprightimg from "../assets/images/marketplace-top-right.png";
import searchicon from "../assets/images/searchicon.svg";
import profileicon from "../assets/images/profileicon.svg";
import stars from "../assets/images/stars.svg";
import starsgray from "../assets/images/starsgray.svg";

import useDebounce from "../hooks/useDebounce";
import { commonservices, CountCharacter } from "../services/CommonServices";
import { CategoryGetList } from "../services/ReduxTookit/Slice/CategoryRedux";
import { GetListBySearch } from "../services/ReduxTookit/Slice/MachineRedux";
import { steps } from "../services/WalkThroughSteps";
import Loader, { LoaderType } from "./common-component/Loader";
import Nodata from "./common-component/Nodata";
import Walkthrough from "./common-component/Walkthrough";

export const renderRatingStars = (rating) => {
  const filledCount = Math.floor(rating || 0);
  const starsArr = [];
  for (let i = 0; i < 5; i++) {
    starsArr.push(
      <img
        key={i}
        src={i < filledCount ? stars : starsgray}
        alt="star"
        className="me-1"
      />,
    );
  }
  return starsArr;
};

function Marketplace() {
  let ProfileInfo = useSelector((state) => state?.userinfo?.UserInfo);
  let DevRoute = window.location.href.includes(`${process.env.REACT_APP_DEV}`);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const walkthroughDetail = commonservices.getWalkthroughDetail();

  // helper to render star images based on average rating

  const [CategoryLoader, setCategoryLoader] = useState(false);
  const [ProjectSearchTerm, setProjectSearchTerm] = useState("");
  const [MachineLoader, setMachineLoader] = useState(false);
  const [MachineList, setMachineList] = useState([]);

  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);
  const [categoryApiLoader, setCategoryApiLoader] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    categoryId: "",
    search: "",
  });
  const debouncingValue = useDebounce(ProjectSearchTerm, 500);
  const isApiCalledRef = useRef(false);
  const [totalRecord, setTotalRecord] = useState(null);
  const [LoadingCategory, setLoadingCategory] = useState(false);

  const dummyMachineList = [
    {
      machineid: 35,
      machinename: "Choice PMS Connection",
      assemblyname: "choice-pms-connection",
      isactive: true,
      createdon: "2024-10-02T00:00:00",
      createdby: 1,
      updatedon: "2024-10-21T09:29:53.024692",
      updatedby: 1,
      machinelogo:
        "https://s3.amazonaws.com/quantamdatalytics/MACHINE/pms.png_638610485029609435?AWSAccessKeyId=AKIAVKTTBCFATMCBQ65L&Expires=1731404351&Signature=BaA6EeGFGUyRMKFq5e78eawiDPU%3D",
      documentpath: null,
      status: "Publish",
      refmachineid: 0,
      versionnumber: "2.4.3",
      dockerimagename: "nitinsuvagia/choicefetchreports:2.4.3",
      dockerimagepath: null,
      price: 15,
      subscriberid: 1,
      lastupdatedon: "2024-11-08T06:43:00.407699",
      lastversion: "2.4.3",
      publishon: "2024-10-02T00:00:00",
      categoryid: 2,
      subcategoryid: null,
      industryid: 1,
      reviewreason: null,
      reviewby: null,
      reviewon: null,
      inputsamplefile: null,
      outputsamplefile: null,
      isprivate: false,
      isdeprecated: null,
      isdiscontinued: true,
      discontinueddate: "2024-12-21T00:00:00",
      deprecateddate: null,
      deprecatedreason: null,
      discontinuereason: "<p>test</p>",
      categoryname: "Reservation",
      shortdescription:
        "Choice PMS Connection refers to the integration between a Property Management System (PMS) and various other systems used in the hospitality industry, such as booking engines, point-of-sale systems, and customer relationship management (CRM) software. Here are some key details",
      subscribername: "Satish Thummar",
      avgrating: 4.5,
    },
  ];
  const dummyCategoryList = [
    {
      categoryid: "",
      categoryname: "All",
    },
    {
      categoryid: 3,
      categoryname: "Utility",
      refcategoryid: 0,
      isactive: true,
      createdby: null,
      createdon: null,
      updatedby: null,
      updatedon: null,
      orderno: 3,
      machinecount: 0,
    },
    {
      categoryid: 4,
      categoryname: "Data Processing",
      refcategoryid: 0,
      isactive: true,
      createdby: null,
      createdon: null,
      updatedby: null,
      updatedon: null,
      orderno: 4,
      machinecount: 0,
    },
    {
      categoryid: 5,
      categoryname: "RevEVOLVE",
      refcategoryid: 0,
      isactive: true,
      createdby: null,
      createdon: null,
      updatedby: null,
      updatedon: null,
      orderno: 5,
      machinecount: 0,
    },
    {
      categoryid: 6,
      categoryname: "Rateshop",
      refcategoryid: 0,
      isactive: true,
      createdby: null,
      createdon: null,
      updatedby: null,
      updatedon: null,
      orderno: 5,
      machinecount: 0,
    },
    {
      categoryid: 7,
      categoryname: "PMS Connection",
      refcategoryid: 0,
      isactive: true,
      createdby: null,
      createdon: null,
      updatedby: null,
      updatedon: null,
      orderno: 5,
      machinecount: 0,
    },
    {
      categoryid: 8,
      categoryname: "Reservation",
      refcategoryid: 0,
      isactive: true,
      createdby: null,
      createdon: null,
      updatedby: null,
      updatedon: null,
      orderno: 5,
      machinecount: 0,
    },
  ];

  const [callApi, setCallApi] = useState(
    walkthroughDetail?.marketPlace ? walkthroughDetail?.marketPlace : false,
  );

  const [showOthersTab, setShowOthersTab] = useState(false);
  const othersTabRef = useRef();

  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  const handleshowMenu = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowOthersTab(!showOthersTab);
  };

  const GetCategoryData = useSelector(
    (state) => state?.categoryredux?.CategoryGetList?.data,
  );

  let categoryList = [];
  if (GetCategoryData?.isValidate) {
    let filterData = GetCategoryData?.data?.data?.filter(
      (x) => x?.refcategoryid === 0,
    );
    categoryList = [{ categoryid: "", categoryname: "All" }, ...filterData];
  }

  const getCategoryList = async () => {
    setCategoryLoader(true);
    let body = {
      categoryname: "",
      subscriberid: "",
    };
    try {
      dispatch(CategoryGetList(body)).then(() => {
        setCategoryLoader(false);
      });
    } catch (error) {
      setLoadingCategory(false);
    }
  };

  async function getMachineList(machineName) {
    if (filter.page === 1) {
      setMachineLoader(true);
      setCategoryApiLoader(true);
    } else {
      setLoading(true);
      loadingRef.current = true;
    }

    let body = {
      machinename: filter.search,
      categoryid: filter?.categoryId ? filter?.categoryId : "",
      industryid: "",
      status: "Publish",
      pagenumber: filter.page,
      pagesize: process.env.REACT_APP_MACHINE_WIDGET_PAGE_SIZE,
    };

    try {
      dispatch(GetListBySearch(body)).then((response) => {
        const { payload } = response;
        if (payload?.isValidate) {
          if (filter.page === 1) {
            setMachineList(payload?.data?.data?.dataList1);
          } else {
            setMachineList((prevData) => [
              ...prevData,
              ...payload?.data?.data?.dataList1,
            ]);
          }

          setTotalRecord(payload?.data?.recordcount);
          setMachineLoader(false);
          setCategoryApiLoader(false);
          loadingRef.current = false;
          setLoading(false);
        }
        if (!payload?.isValidate) {
          setLoading(false);
          setCategoryApiLoader(false);
          setMachineList([]);
          setTotalRecord(null);
          loadingRef.current = false;
          setMachineLoader(false);
        }

        setMachineLoader(false);
      });
    } catch (error) {
      setMachineLoader(false);
    }
  }

  const handleOthersTabModal = (index, categoryId) => {
    if (filter.categoryId === categoryId) return;
    setMachineLoader(true);
    setActiveTab(index);
    let updatedFilter = { ...filter };
    updatedFilter.page = 1;
    updatedFilter.categoryId = categoryId;
    setFilter(updatedFilter);
  };

  useEffect(() => {
    if (callApi) {
      getCategoryList();
    }
  }, [callApi]);

  useEffect(() => {
    if (isApiCalledRef.current) {
      let updatedFilter = { ...filter };
      updatedFilter.page = 1;
      updatedFilter.search = debouncingValue;
      setFilter(updatedFilter);
    }
  }, [debouncingValue]);

  useEffect(() => {
    if (callApi) {
      isApiCalledRef.current = true;
      getMachineList();
    }
  }, [callApi, filter]);

  const handleScroll = () => {
    const scrollDiv = document.querySelector(".market-place-main-stickyaction");
    const scrollPosition = scrollDiv.scrollTop + scrollDiv.clientHeight;
    const bottomPosition = scrollDiv.scrollHeight - 300;
    if (
      scrollPosition >= bottomPosition &&
      !loadingRef.current &&
      !loading &&
      MachineList?.length < totalRecord
    ) {
      loadingRef.current = true;
      let updatedFilter = { ...filter };
      updatedFilter.page = updatedFilter.page + 1;
      setFilter(updatedFilter);
    }
  };

  useEffect(() => {
    const scrollDiv = document.querySelector(".market-place-main-stickyaction");
    const debouncedScroll = debounce(handleScroll, 200);
    if (scrollDiv) {
      scrollDiv.addEventListener("scroll", debouncedScroll);
    }
    return () => {
      if (scrollDiv) {
        scrollDiv.removeEventListener("scroll", debouncedScroll);
      }
    };
  });

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollPosition = window.innerHeight + window.scrollY;
  //     const bottomPosition = document.body.scrollHeight - 300;
  //     if (
  //       scrollPosition >= bottomPosition &&
  //       !loadingRef.current &&
  //       !loading &&
  //       MachineList?.length < totalRecord
  //     ) {
  //       loadingRef.current = true;
  //       let updatedFilter = { ...filter };
  //       updatedFilter.page = updatedFilter.page + 1;
  //       setFilter(updatedFilter);
  //     }
  //   };
  //   const debouncedScroll = debounce(handleScroll, 200);
  //   window.addEventListener("scroll", debouncedScroll);
  //   return () => {
  //     window.removeEventListener("scroll", debouncedScroll);
  //   };
  // });

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  const [activeTab, setActiveTab] = useState(0);
  const [showSearch, setShowSearch] = useState(false);

  const handleshowSearch = () => {
    setShowSearch(!showSearch);
  };

  const handleWalkthroughCallback = () => {
    setCallApi(true);
  };

  const fnMachineDetail = (machine_id) => {
    let Data = commonservices.bodyEncryption(String(machine_id));
    navigate(`/marketplace/marketplace-detail/${Data}/Marketplace`);
  };


  return (
    <div
      className={
        callApi ? "marketplace-page" : "marketplace-page walkthrough-open"
      }
    >
      <div className="marketplace-page-inner">
        <Walkthrough
          callback={handleWalkthroughCallback}
          steps={DevRoute ? steps?.Marketplace : steps?.MarketplaceWorkflow}
          run={!callApi}
          keyName="marketPlace"
        />

        <div className="marketplace-top">
          <div className="marketplace-title">
            <h1 className="mb-0">Explore Marketplace</h1>
            {DevRoute ? (
              <Link
                to="/marketplace/addMachine"
                className="green-btn tourMarketPlaceUploadMachine"
              >
                Upload My Machine
              </Link>
            ) : (
              ""
            )}
          </div>
          <p>
            Discover a variety of tools and services tailored to enhance your
            business operations. From property management systems to advanced
            analytics, explore solutions that empower you to make smarter
            decisions and achieve better outcomes.
          </p>
          <div className="header-search-input searchplaceholder">
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                <img
                  src={searchicon}
                  alt="searchicon"
                  onClick={handleshowSearch}
                  className="cursor-pointer"
                />
              </InputGroup.Text>
              <Form.Control
                placeholder="Search Marketplace"
                aria-label="Search"
                aria-describedby="basic-addon1"
                value={ProjectSearchTerm}
                onChange={(e) => {
                  setProjectSearchTerm(e.target.value);
                }}
              />
            </InputGroup>
          </div>
        </div>
        <div className={categoryApiLoader ? "disableClickEvent" : ""}>
          <div className="marekplace-grid">
            <div className="custom-tabing">
              <h3>Browse by Category</h3>
              <div className="custom-tabing-list tourMarketPlaceFilterIndustry">
                {CategoryLoader ? (
                  <div>
                    <div className="single-tab ">
                      <Skeleton height={15} width={200} />
                    </div>
                    <div className="single-tab ">
                      <Skeleton height={15} width={200} />
                    </div>
                     <div className="single-tab ">
                      <Skeleton height={15} width={200} />
                    </div>
                     <div className="single-tab ">
                      <Skeleton height={15} width={200} />
                    </div>
                     <div className="single-tab ">
                      <Skeleton height={15} width={200} />
                    </div>
                     <div className="single-tab ">
                      <Skeleton height={15} width={200} />
                    </div>
                  </div>
                ) : !callApi ? (
                  dummyCategoryList?.map((item, index) => {
                    return (
                      <div
                        key={item?.categoryid}
                        className={
                          activeTab === index
                            ? "single-tab active"
                            : "single-tab"
                        }
                      >
                        <span>{item.categoryname}</span>
                      </div>
                    );
                  })
                ) : categoryList?.length > 0 ? (
                  <>
                    {categoryList?.map((item, index) => {
                      // if (index <= 4) {
                      return (
                        <div
                          key={item?.categoryid}
                          className={
                            activeTab === index
                              ? "single-tab active"
                              : "single-tab"
                          }
                          onClick={() => {
                            if (filter.categoryId === item?.categoryid) {
                              return;
                            } else {
                              setMachineLoader(true);
                              setActiveTab(index);
                              let updatedFilter = { ...filter };
                              updatedFilter.page = 1;
                              updatedFilter.categoryId = item?.categoryid;
                              setFilter(updatedFilter);
                              window.scrollTo(0, 0);
                            }
                          }}
                        >
                          <span>{item.categoryname}</span>
                        </div>
                      );
                      // }
                    })}
                    {/* {categoryList?.length > 5 && (
                      <div
                        className={
                          activeTab > 4 ? "single-tab active" : "single-tab"
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setShowOthersTab(!showOthersTab);
                          handleshowMenu();
                        }}
                        ref={othersTabRef}
                      >
                        <span>Others</span>
                      </div>
                    )} */}
                  </>
                ) : (
                  <div className="single-tab">
                    <span>No Data found.</span>
                  </div>
                )}
              </div>
            </div>
            <div>
              {MachineLoader ? (
                <>
                  <Loader type={LoaderType.NewCardWidgets} count={6} />
                </>
              ) : (
                <>
                  {!callApi ? (
                    <div className="all-market-place-main">
                      {dummyMachineList?.map((item_m, index_m) => (
                        // <div
                        //   key={index_m}
                        //   className="single-market-place-main cursor-pointer"
                        //   onClick={(e) => {
                        //     e.preventDefault();
                        //     fnMachineDetail(item_m?.machineid);
                        //   }}
                        // >
                        //   <div className="d-flex align-items-center justify-content-between sehedular-card-inner-size">
                        //     <div className="d-flex gap-2 align-items-center">
                        //       <div className="single-market-place-img tourMarketPlaceMachineIcon">
                        //         <img
                        //           src={
                        //             item_m?.machinelogo !== "" &&
                        //             item_m?.machinelogo !== null
                        //               ? item_m?.machinelogo
                        //               : DemoLogo
                        //           }
                        //           onError={({ currentTarget }) => {
                        //             currentTarget.onerror = null;
                        //             currentTarget.src = DemoLogo;
                        //           }}
                        //           alt="machine logo"
                        //         />
                        //       </div>
                        //       <div className="market-place-content-title tourMarkePlaceMachineDetail">
                        //         <h4 title={item_m?.machinename}>
                        //           {commonservices.truncateText(
                        //             item_m?.machinename,
                        //             CountCharacter.MachineName,
                        //           )}
                        //         </h4>
                        //       </div>
                        //     </div>
                        //     <h3 className="report-price-single tourMarketPlaceMachinePrice">
                        //       {item_m?.price > 0
                        //         ? `$ ${item_m?.price?.toFixed(2)}`
                        //         : "Free"}
                        //     </h3>
                        //   </div>
                        //   <div className="market-place-content">
                        //     <div className=" d-flex align-items-center justify-content-between mb-1 ">
                        //       <span className="blue-badge">
                        //         {item_m?.categoryname}
                        //       </span>
                        //       <div className="market-place-content-title">
                        //         {item_m?.avgrating > 0 && (
                        //           <div className="market-place-content-ratings">
                        //             <img src={stars} alt="stars" />
                        //             <span>{item_m?.avgrating?.toFixed(1)}</span>
                        //           </div>
                        //         )}
                        //       </div>
                        //     </div>
                        //     <p
                        //       title={commonservices.stripHTML(
                        //         item_m?.shortdescription,
                        //       )}
                        //       dangerouslySetInnerHTML={{
                        //         __html: item_m?.shortdescription
                        //           ? commonservices.truncateText(
                        //               commonservices.stripHTML(
                        //                 item_m?.shortdescription,
                        //               ),
                        //               CountCharacter.MachineShortDetail,
                        //             )
                        //           : "",
                        //       }}
                        //     />

                        //     <div className="d-flex align-items-end justify-content-between ">
                        //       <div className="developer-name">
                        //         <span className="developer">Developer</span>
                        //         <div className="tourMarketPlaceDevName">
                        //           <span>
                        //             <Link
                        //               to="/marketplace/developer"
                        //               state={{
                        //                 subscriberId: item_m?.subscriberid,
                        //               }}
                        //               onClick={(e) => e.stopPropagation()}
                        //             >
                        //               {item_m?.subscribername}
                        //             </Link>
                        //           </span>
                        //         </div>
                        //       </div>
                        //       <div className="crossarrow ms-auto tourMarketPlaceExploreBtn">
                        //         <img src={crossarrow} alt="crossarrow" />
                        //       </div>
                        //     </div>
                        //   </div>
                        // </div>
                        <div
                          key={index_m}
                          className=" single-market-place-main new-single-market-place-main cursor-pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            fnMachineDetail(item_m?.machineid);
                          }}
                        >

                          <div className="single-market-place-img tourMarketPlaceMachineIcon">
                            <img
                              src={
                                item_m?.machinelogo !== "" &&
                                  item_m?.machinelogo !== null
                                  ? item_m?.machinelogo
                                  : DemoLogo
                              }
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = DemoLogo;
                              }}
                              alt="machine logo"
                            />
                          </div>
                          <div className="machine-card-right-content">
                            <span className="tourMarkePlaceMachineDetail">
                              <h4 title={item_m?.machinename}>
                                {item_m?.machinename}
                              </h4>
                            </span>
                            <div className="rating-user-box">
                              {/* <span className="blue-badge">
                                      {item_m?.categoryname}
                                    </span> */}
                              <span className="blue-badge">
                                {item_m?.ratingcount || 0} user
                              </span>
                              {item_m?.avgrating > 0 ? (
                                <div className="market-place-content-ratings">
                                  {renderRatingStars(item_m?.avgrating)}
                                  <span>{item_m?.avgrating?.toFixed(1)}</span>
                                </div>
                              ) : (
                                <div className="market-place-content-ratings">
                                  {renderRatingStars(0)}
                                  <span>{0}</span>
                                </div>
                              )}
                            </div>
                            <p
                              className="description-text-limited"
                              title={commonservices.stripHTML(
                                item_m.shortdescription,
                              )}
                            >
                              {item_m?.shortdescription
                                ? commonservices.stripHTML(
                                  item_m.shortdescription,
                                )
                                : ""}
                            </p>
                            <span className="tourMarketPlaceDevName d-inline-block">
                              <span className="developer-box">
                                <img src={profileicon} alt="profileicon" />
                                <Link
                                  to="/marketplace/developer"
                                  state={{
                                    subscriberId: item_m?.subscriberid,
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {item_m?.subscribername}
                                </Link>
                              </span>
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : !MachineLoader && MachineList?.length > 0 ? (
                    <>
                      <div className="market-place-main-stickyaction">
                        <div className="all-market-place-main">
                          {MachineList?.map((item_m, index_m) => (
                            <>
                              <div
                                key={index_m}
                                className=" single-market-place-main new-single-market-place-main cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  fnMachineDetail(item_m?.machineid);
                                }}
                              >

                                <div className="single-market-place-img ">
                                  <img
                                    src={
                                      item_m?.machinelogo !== "" &&
                                        item_m?.machinelogo !== null
                                        ? item_m?.machinelogo
                                        : DemoLogo
                                    }
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null;
                                      currentTarget.src = DemoLogo;
                                    }}
                                    alt="machine logo"
                                  />
                                </div>
                                <div className="machine-card-right-content">
                                  <h4 title={item_m?.machinename}>
                                    {item_m?.machinename}
                                  </h4>
                                  <div className="rating-user-box">
                                    {/* <span className="blue-badge">
                                      {item_m?.categoryname}
                                    </span> */}
                                    <span className="blue-badge">
                                      {item_m?.ratingcount || 0} user
                                    </span>
                                    {item_m?.avgrating > 0 ? (
                                      <div className="market-place-content-ratings">
                                        {renderRatingStars(item_m?.avgrating)}
                                        <span>
                                          {item_m?.avgrating?.toFixed(1)}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="market-place-content-ratings">
                                        {renderRatingStars(0)}
                                        <span>{0}</span>
                                      </div>
                                    )}
                                  </div>
                                  <p
                                    className="description-text-limited"
                                    title={commonservices.stripHTML(
                                      item_m.shortdescription,
                                    )}
                                  >
                                    {item_m?.shortdescription
                                      ? commonservices.stripHTML(
                                        item_m.shortdescription,
                                      )
                                      : ""}
                                  </p>
                                  <span className="developer-box">
                                    <img src={profileicon} alt="profileicon" />
                                    <Link
                                      to="/marketplace/developer"
                                      state={{
                                        subscriberId: item_m?.subscriberid,
                                      }}
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      {item_m?.subscribername}
                                    </Link>
                                  </span>
                                </div>
                              </div>
                            </>
                          ))}

                          {loading ? (
                            <>
                              <Loader
                                type={LoaderType.MachineCardLoader}
                                count={6}
                              />
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <Nodata />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        {showOthersTab && (
          <Overlay
            target={othersTabRef.current}
            show={showOthersTab}
            placement="bottom-end"
          >
            {(props) => (
              <Tooltip
                id="overlay-example"
                {...props}
                className="other-data-tooltip-box"
              >
                <CategoryListTab
                  handleshowPopup={handleshowMenu}
                  categoryList={categoryList}
                  handleCategoryClick={handleOthersTabModal}
                  selectedCategory={activeTab}
                />
              </Tooltip>
            )}
          </Overlay>
        )}
      </div>
    </div>
  );
}

export default Marketplace;
